module.exports = __webpack_public_path__ + "media/bootstrap-icons/music-player-e252f63b.svg";